import React, { useState, useEffect } from 'react';
import './App.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://fishtankapi.jianc.dpdns.org';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState('login');
  const [bindCode, setBindCode] = useState('');
  const [bindError, setBindError] = useState('');
  const [bindSuccess, setBindSuccess] = useState('');

  useEffect(() => {
    if (token) {
      setPage('dashboard');
      fetchDevices();
    } else {
      setPage('login');
    }
  }, [token]);

  const fetchDevices = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/devices`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setDevices(Array.isArray(data) ? data : []);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const controlDevice = async (deviceId, action) => {
    try {
      await fetch(`${API_URL}/api/devices/${deviceId}/command`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ action })
      });
      fetchDevices();
    } catch (e) { alert('控制失败'); }
  };

  const handleBind = async (e) => {
    e.preventDefault();
    setBindError('');
    setBindSuccess('');
    try {
      const res = await fetch(`${API_URL}/api/devices/bind`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ bind_code: bindCode })
      });
      const data = await res.json();
      if (data.success) {
        setBindSuccess('绑定成功！');
        fetchDevices();
        setBindCode('');
      } else {
        setBindError(data.error || '绑定失败');
      }
    } catch (e) { setBindError('网络错误'); }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setPage('login');
  };

  if (page === 'login') {
    return <LoginPage onLogin={setToken} onSwitch={() => setPage('register')} />;
  }
  if (page === 'register') {
    return <RegisterPage onSwitch={() => setPage('login')} />;
  }

  return (
    <div className="dashboard">
      <header className="glass-header">
        <h1>🐟 智能鱼缸</h1>
        <button onClick={logout} className="glass-btn">退出</button>
      </header>
      <div className="content">
        <div className="bind-section glass-card">
          <h3>绑定新设备</h3>
          <form onSubmit={handleBind}>
            <input
              type="text"
              placeholder="输入 6 位绑定码"
              value={bindCode}
              onChange={(e) => setBindCode(e.target.value)}
              maxLength="6"
            />
            <button type="submit" className="glass-btn">绑定</button>
          </form>
          {bindError && <p className="error">{bindError}</p>}
          {bindSuccess && <p className="success">{bindSuccess}</p>}
        </div>
        <div className="device-grid">
          {loading ? <p>加载中...</p> :
            devices.length === 0 ? <p>暂无设备，请绑定。</p> :
            devices.map(d => (
              <div key={d.id} className="device-card glass-card">
                <h3>{d.name || d.mac}</h3>
                <p>状态: {d.last_seen ? '在线' : '离线'}</p>
                <button onClick={() => controlDevice(d.id, 'toggle_pump')} className="glass-btn">切换水泵</button>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

// ===== 登录组件 =====
function LoginPage({ onLogin, onSwitch }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem('token', data.token);
        onLogin(data.token);
      } else {
        setError(data.error || '登录失败');
      }
    } catch (e) { setError('网络错误'); }
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card glass-card">
        <h2>登录</h2>
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="用户名" value={username} onChange={e => setUsername(e.target.value)} required />
          <input type="password" placeholder="密码" value={password} onChange={e => setPassword(e.target.value)} required />
          {error && <p className="error">{error}</p>}
          <button type="submit" className="glass-btn" disabled={loading}>{loading ? '登录中...' : '登录'}</button>
        </form>
        <p>还没有账号？<button onClick={onSwitch} className="link-btn">注册</button></p>
      </div>
    </div>
  );
}

// ===== 注册组件 =====
function RegisterPage({ onSwitch }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (password !== confirm) return setError('密码不一致');
    if (password.length < 3) return setError('密码至少3位');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (data.success) {
        setSuccess('注册成功，请登录');
        setTimeout(onSwitch, 1500);
      } else {
        setError(data.error || '注册失败');
      }
    } catch (e) { setError('网络错误'); }
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card glass-card">
        <h2>注册</h2>
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="用户名" value={username} onChange={e => setUsername(e.target.value)} required />
          <input type="password" placeholder="密码" value={password} onChange={e => setPassword(e.target.value)} required />
          <input type="password" placeholder="确认密码" value={confirm} onChange={e => setConfirm(e.target.value)} required />
          {error && <p className="error">{error}</p>}
          {success && <p className="success">{success}</p>}
          <button type="submit" className="glass-btn" disabled={loading}>{loading ? '注册中...' : '注册'}</button>
        </form>
        <p>已有账号？<button onClick={onSwitch} className="link-btn">登录</button></p>
      </div>
    </div>
  );
}

export default App;